import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../assets/css/seller/SupportInSeller/SupportInSeller.css";
import SellerMasterLayout from "../../../layout/seller/SellerMasterLayout";
import AppContext from "../../../context/AppContext";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

/* ── Icons ── */
const IconChat = () => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    width="15"
    height="15"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2 5a2 2 0 012-2h12a2 2 0 012 2v7a2 2 0 01-2 2H7l-4 3V5z"
    />
  </svg>
);

const IconPlus = () => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    width="14"
    height="14"
  >
    <path strokeLinecap="round" d="M10 3v14M3 10h14" />
  </svg>
);

/* ── Helpers ── */
const getInitials = (name = "") =>
  name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

/* ── Status Badge ── */
const StatusBadge = ({ status }) => {
  const map = {
    Open: "open",
    Resolved: "resolved",
    Closed: "closed",
    Pending: "pending",
  };
  return (
    <span className={`tfp-badge tfp-badge--${map[status] || "closed"}`}>
      {status}
    </span>
  );
};

/* ── Chat Button ── */
const ChatBtn = ({ ticketId }) => {
  const navigate = useNavigate();

  return (
    <button
      className="tfp-btn-chat"
      onClick={() => { console.log("ticketId =", ticketId); 
         navigate(`/customer-chat/${ticketId}`)}}
    >
      <IconChat />
    </button>
  );
};
/* ── Static Data ── */
// const DISPUTES = [
//   {
//     id: "DSP-001",
//     order: "ORD-003",
//     customer: "Usman Tariq",
//     reason: "Service not delivered",
//     status: "Open",
//   },
//   {
//     id: "DSP-002",
//     order: "ORD-005",
//     customer: "Ali Raza",
//     reason: "Quality below expectations",
//     status: "Resolved",
//   },
// ];

/* ── Customer Disputes Table ── */
// const CustomerDisputes = ({ disputes }) => (
//   <div className="tfp-card">
//     <div className="tfp-card__header">
//       <h2>Customer Disputes</h2>
//       <span className="tfp-card__count">{disputes.length} total</span>
//     </div>

//     <div className="tfp-table-wrapper">
//       <table className="tfp-table">
//         <thead>
//           <tr>
//             <th>Dispute</th>
//             <th>Order</th>
//             <th>Customer</th>
//             <th>Reason</th>
//             <th>Status</th>
//             <th>Chat</th>
//           </tr>
//         </thead>
//         <tbody>
//           {disputes.length === 0 ? (
//             <tr>
//               <td colSpan={6} className="tfp-empty">
//                 No disputes found.
//               </td>
//             </tr>
//           ) : (
//             disputes.map((d) => (
//               <tr key={d.id}>
//                 <td className="tfp-cell-id">{d.id}</td>
//                 <td className="tfp-cell-id">{d.order}</td>
//                 <td>
//                   <div className="tfp-cell-customer">
//                     <span className="tfp-avatar">
//                       {getInitials(d.customer)}
//                     </span>
//                     {d.customer}
//                   </div>
//                 </td>
//                 <td>{d.reason}</td>
//                 <td>
//                   <StatusBadge status={d.status} />
//                 </td>
//                 <td>
//                   <ChatBtn ticketId={d.id} />
//                 </td>
//               </tr>
//             ))
//           )}
//         </tbody>
//       </table>
//     </div>
//   </div>
// );

/* ── Raise Ticket Form ── */
const RaiseTicketForm = ({ onTicketAdded, setTickets }) => {
  const [title, setTitle] = useState("");
  const [order_id, setOrder_id] = useState("");
  const [issue_type, setIssue_type] = useState("");
  const [description, setDescription] = useState("");
  const { baseUrl, loggedInCustomer } = useContext(AppContext);
 
  const SubmitTicket = () => {

  if (!loggedInCustomer?.id) {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Customer not loaded",
    });
    return;
  }

  const formData = new FormData();
  formData.append("title", title);
  formData.append("order_id", order_id);
  formData.append("issue_type", issue_type);
  formData.append("description", description);
  formData.append("generated_by", "customer");
  formData.append("tpcustomers_id", loggedInCustomer.id);

  axios
    .post(`${baseUrl}/customer/general/helpSupportCustomer`, formData)
    .then((response) => {

      Swal.fire({
        icon: "success",
        title: "Ticket Submitted",
        text: "Your support ticket has been submitted successfully.",
      });

      setTitle("");
      setOrder_id("");
      setIssue_type("");
      setDescription("");

      if (onTicketAdded) {
        onTicketAdded();
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

 useEffect(() => {
  
  console.log("Customer:", loggedInCustomer);
}, [loggedInCustomer]);

  return (
    <div className="tfp-card">
      <div className="tfp-card__header">
        <h2>Raise Ticket to Admin</h2>
      </div>

      <div className="tfp-card__body">
        <Row>
          <Col>
            <div className="tfp-form-row">
              <input
                className="tfp-input"
                placeholder="Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
          </Col>
        </Row>

         <Row>
          <Col>
            <div className="tfp-form-row">
              <input
                className="tfp-input"
                placeholder="Order_id"
                value={order_id}
                onChange={(e) => setOrder_id(e.target.value)}
              />
            </div>
          </Col>
        </Row>

         <Row>
          <Col>
            <div className="tfp-form-row">
              <input
                className="tfp-input"
                placeholder="Issue_type"
                value={issue_type}
                onChange={(e) => setIssue_type(e.target.value)}
              />
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className="tfp-form-row">
              <textarea
                className="tfp-textarea"
                placeholder="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </Col>
        </Row>

        <button type="button" className="tfp-btn-submit" onClick={SubmitTicket}>
          <IconPlus /> Submit Ticket
        </button>
      </div>
    </div>
  );
};

/* ── My Tickets Table ── */
const MyTickets = ({ tickets }) => (
  <div className="tfp-card">
    <div className="tfp-card__header">
      <h2>My Tickets</h2>
      <span className="tfp-card__count">{tickets.length} total</span>
    </div>

    <div className="tfp-table-wrapper">
      <table className="tfp-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Description</th>
            <th>Status</th>
            <th>Date</th>
            <th>Chat</th>
          </tr>
        </thead>
        <tbody>
          {tickets.length === 0 ? (
            <tr>
              <td colSpan={6} className="tfp-empty">
                No tickets raised yet.
              </td>
            </tr>
          ) : (
            tickets.map((t) => (
              <tr key={t.id}>
                <td className="tfp-cell-id">{t.id}</td>
                <td>{t.title}</td>
                <td>{t.description}</td>
                <td>
                  <StatusBadge status={t.status} />
                </td>
                <td>{t.created_at}</td>
                <td>
                  <ChatBtn ticketId={t.id} />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  </div>
);

/* ── Main Page ── */
const SupporttInCustomer = () => {
  const [tickets, setTickets] = useState([]);
  const [disputes, setDisputes] = useState([]);
  const { baseUrl, loggedInCustomer } = useContext(AppContext);


  const viewMyTickets = () => {
  if (!loggedInCustomer?.id) return;

  const formData = new FormData();
  formData.append("tpcustomer_id", loggedInCustomer.id);

  axios
    .post(`${baseUrl}/customer/general/viewMyTickets`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      setTickets(response.data.tickets || []);
    })
    .catch((err) => {
      console.log(err);
    });
};

const viewMyCustomerTickets = () => {
  if (!loggedInCustomer?.id) return;

  const formData = new FormData();

  // Customer login hai to customer id bhejo
  formData.append("tpcustomer_id", loggedInCustomer.id);

  axios
    .post(`${baseUrl}/customer/general/viewMyCustomerTickets`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      setDisputes(response.data.tickets || []);
    })
    .catch((err) => {
      console.log(err);
    });
};



 useEffect(() => {
  if (loggedInCustomer?.id) {
    viewMyTickets();
    viewMyCustomerTickets();
  }
}, [loggedInCustomer]);
  return (
    <SellerMasterLayout>
      <div className="tfp-support-page">
        <Container>
          <h1 className="tfp-page-heading">Support & Disputes</h1>
          {/* <CustomerDisputes disputes={disputes} /> */}
          <RaiseTicketForm
            setTickets={setTickets}
            onTicketAdded={viewMyTickets}
          />
          <MyTickets tickets={tickets} />
        </Container>
      </div>
    </SellerMasterLayout>
  );
};

export default SupporttInCustomer;
